import { createContext, ReactNode, useState } from 'react';
import { getLocalStorage } from '../../infra/cache/LocalstorageCache';
import { UserLogged } from '../../domain/contract/UserLogged';
import { jwtDecode } from 'jwt-decode';
import { LocalStorageKeysConstant } from '../../main/constant/LocalStorageKeysConstant';

export const AuthContext = createContext({} as AuthContextType);

export type ProviderPropsType = { children: ReactNode };
export type AuthContextType = {
  isLogged: boolean;
  setIsLogged: (status: boolean) => void;
  loggedUserData?: UserLogged | null;
};

/**
 * AuthProvider - provedor para usuario logado
 * @param props
 * @constructor
 */
export function AuthProvider(props: ProviderPropsType) {
  const TOKEN_USER_LOGIN = LocalStorageKeysConstant.tokenUserLogin;
  const tokenLocalStorage = getLocalStorage(TOKEN_USER_LOGIN ?? 'intelidente-token-login');

  // Verificação se o token existe no localStorage
  const isTokenValid = !!tokenLocalStorage && !!tokenLocalStorage.auth;
  let decodedLogin: any = null;
  let intelidenteRoles: string[] = [];

  if (isTokenValid) {
    // Decodifica o token e extrai os roles se o token existir
    decodedLogin = jwtDecode(tokenLocalStorage.auth);
    const resourceAccess = decodedLogin?.resource_access;
    intelidenteRoles = resourceAccess?.['intelidente-lite-services']?.roles || [];
  }

  // Inicializa isLogged com base na presença do token
  const [isLogged, setIsLogged] = useState<boolean>(isTokenValid);

  // Define os dados do usuário com base no token ou como null
  const loggedUserData: UserLogged | null = isTokenValid
    ? {
        id: 0,
        name: tokenLocalStorage?.name || null,
        login: tokenLocalStorage?.login || null,
        token: tokenLocalStorage?.auth || null,
        roles: intelidenteRoles,
      }
    : null; // Quando não houver token, `loggedUserData` será null

  return <AuthContext.Provider value={{ isLogged, setIsLogged, loggedUserData }}>{props.children}</AuthContext.Provider>;
}
